const { USD, GBP, EUR, SGD } = require("@dinero.js/currencies");

const Currencies = {
  USD,
  EUR,
  SGD,
  GBP,
};

module.exports = {
  Currencies,
};
